import { ConnectedAccountActivityStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const ConnectedAccountActivityStatusMapping = {
    [ConnectedAccountActivityStatus.Settled]: 'success',
    [ConnectedAccountActivityStatus.Pending]: 'info',
    [ConnectedAccountActivityStatus.Cancelled]: 'secondary',
} as { [key in ConnectedAccountActivityStatus]: EnumColor };
